import none from '../../img/leoLogo.png'

export const other=[
    {
      "id": "231",
      "title": "سرویس سس",
      "desciption": "",
      "price": "100",
      "image": none
    },
    {
      "id": "232",
      "title": "لیوان یخ",
      "desciption": "",
      "price": "20",
      "image": none
    },
    {
      "id": "233",
      "title": "حق سرویس تولد هر نفر ",
      "desciption": "",
      "price": "50",
      "image": none
    },
    {
      "id": "234",
      "title": "بازی PS5",
      "desciption": "",
      "price": "50",
      "image": none
    },
    {
      "id": "235",
      "title": "بازی برد گیم برای هر نفر ",
      "desciption": "",
      "price": "25",
      "image": none
    },
    {
      "id": "236",
      "title": "سفارشی ندارم",
      "desciption": "",
      "price": "40",
      "image": none
    },
    // {
    //   "id": "23",
    //   "title": "",
    //   "desciption": "",
    //   "price": "",
    //   "image": none
    // },
    
  ]